import { USERTYPES } from "../../../constants/Constants";
import { t } from "i18next";
import { getEnv } from '../../../helpers/EnvHelper';

/**
 * Returns an array of option objects for report template categories that
 * should be shown to the current user.
 * Logic copied from TemplateCategory.getReportTemplate, with params injected
 * instead of relying on context so it can be reused.
 *
 * @param {Object} params
 * @param {boolean} params.isDSRExists
 * @param {boolean} params.isClientReportExist
 * @param {boolean} params.isRestrictionsEnabled
 * @param {string}  params.modality
 * @param {string}  params.userRole
 * @returns {{key:string,text:string}[]}
 */
export const getReportTemplateOptions = ({
  isDSRExists,
  isClientReportExist,
  isRestrictionsEnabled,
  modality = "",
  userRole = "",
}) => {
  let reportTemplateOptions = [];

  // if (isDSRExists) {
  //   reportTemplateOptions.push({
  //     key: "dsrTemplate",
  //     text: t("report.llm-report"),
  //   });
  // }

  reportTemplateOptions.push({
    key: "deeptekReportTemplage",
    text:
      getEnv("REACT_APP_VDC_PLATFORM") == "true"
        ? t("report.vdc-report")
        : t("report.deeptek-report-llm"),
  });

  if (isClientReportExist) {
    reportTemplateOptions.push({
      key: "clientReportTemplate",
      text: "Client Template",
    });
  }

  if (
    (userRole === USERTYPES.RADIOLOGIST || userRole === USERTYPES.TYPIST) &&
    getEnv("REACT_APP_VDC_PLATFORM") == "false"
  ) {
    reportTemplateOptions.push({
      key: "radiologistReportTemplate",
      text: t("report.radiologist-report-llm"),
    });
  }

  // if (
  //   modality.length > 0 &&
  //   modality !== "MR" &&
  //   modality !== "CT" &&
  //   (userRole === USERTYPES.RADIOLOGIST || userRole === USERTYPES.TYPIST) &&
  //   import.meta.env.VITE_VDC_PLATFORM == "false"
  // ) {
  //   reportTemplateOptions.push({
  //     key: "rsnaReportTemplage",
  //     text: t("report.rsna-report"),
  //   });
  // }

  if (isRestrictionsEnabled && isClientReportExist) {
    return reportTemplateOptions.filter((opt) => opt.key === "clientReportTemplate");
  }

  return reportTemplateOptions;
};
